import { render, staticRenderFns } from "./C2BBinding.vue?vue&type=template&id=1986cd94&scoped=true&"
import script from "./C2BBinding.vue?vue&type=script&lang=ts&"
export * from "./C2BBinding.vue?vue&type=script&lang=ts&"
import style0 from "./C2BBinding.vue?vue&type=style&index=0&id=1986cd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986cd94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VSelect,VTextField})
